import i18n from './i18n';

export const syncTranslationsFromRedux = (resources, lng, languages) => {
    const ietfbcP47 = languages.find(x => x.id === lng).ietfbcP47;
    i18n.addResourceBundle(ietfbcP47, 'translation', resources);
    i18n.changeLanguage(ietfbcP47);
};
